import { Component, Input, OnInit, TemplateRef,ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import {
AdvancedComponent, Browser, ButtonService, CardConfig, CardTitleConfig,
ColumnDef, Command, Consts, DataCardComponent, DMValidators, FormControl, FormGroup, JobResponse,
LazyloadService, PromptConfigFull,
    Rest, TableConfig, TimeService, UNPLACEHOLDER, UtilService } from '@dm/core';
import { ButtonGroup } from '@dm/core/types';
import { MO } from 'app/common/constants';
import { ScheduleTypeE } from 'app/common/constants/hyper-cdp.const';
import { LicenseKey } from 'app/common/constants/license-key';
import { FileSystem, FilesystemSnapshot, HyperCdpSchedule } from 'app/common/types/mo';
import { SWITCH } from 'app/config/switch';
import { CreateComponent } from 'app/feature/protection/schedule/hyper-cdp/schedule/create/create.component';
import { objectTypeE } from 'app/feature/protection/schedule/hyper-cdp/schedule/create/create-str.service';
import { ScheduleService } from 'app/feature/protection/schedule/hyper-cdp/schedule/schedule.service';
import { ScheduleStrService } from 'app/feature/protection/schedule/hyper-cdp/schedule/schedule-str.service';
import { SIMPLE_CDP_SCHEDULE_NAS_DEFAULT } from 'app/feature/protection/simple-protection/simple-protection.const';
import { SYSTEM_VSTORE_NAME } from 'app/feature/service/file-service/share/data-turbo-share/data-turbo-share-str.service';
import { SystemVstoreId } from 'app/feature/system/hardware/device/detail/detail.str.service';
import { Observable, of } from 'rxjs';

import { SnapProtectTypeE, SnapSourceSelectTypeE } from '../../../lun/snapshot/create-form/create-lun-snapshot-form.enum';
import { FilesystemSnapshotService } from '../filesystem-snapshot.service';
import { FilesystemSnapshotStrService, protectPeriodConstE, protectPeriodUnitE } from '../filesystem-snapshot-str.service';
import { SnapTypeE } from './../filesystem-snapshot-str.service';
import { CreateFsSnapFormValue } from './create-fs-snap-form';
import { FsSnapCreateDesLenE, FsSnapCreateNameLenE, FsSnapTagLenE } from './create-fs-snap-form.enum';

@Component({
    selector: 'app-create-fs-snap-form',
    templateUrl: './create-fs-snap-form.component.html',
    styleUrls: ['./create-fs-snap-form.component.scss'],
})
export class CreateFsSnapFormComponent implements OnInit {
    /**
     * 选择类型，单选or多选
     */
    @Input() selectType: SnapSourceSelectTypeE = SnapSourceSelectTypeE.Multi;
    /**
     * 已选中的fs
     */
    @Input() selectedFs: FileSystem[] = [];
    /**
     * 是否cdp
     */
    @Input() isCdp = false;

    /**
     * 显示添加策略选项
     */
    @Input() showSchedule = false;

    /**
     * 显示单次快照选项
     */
    @Input() showSnap = true;

    /**
     * 是否为修改CDP策略场景
     */
    @Input() modifySchedule = false;

    /**
     * 可选Fs推拉表格ref
     */
    @ViewChild('selectedFsToggle') selectedFsToggle: AdvancedComponent;

    /**
     * cdp策略卡片 ref
     */
    @ViewChild('scheduleDataCard') scheduleDataCard: DataCardComponent;

    /**
     * 修改策略高危提示table ref
     */
     @ViewChild('modifyScheduleTableTemplate') modifyScheduleTableTemplate: TemplateRef<any>;

    /**
     * 常量定义
     */
    isSimpleMode = SWITCH.IS_SIMPLE_MODE;
    SnapProtectTypeE = SnapProtectTypeE;
    i18n = this.str.i18n;
    protectPeriodOptions = this.str.protectPeriodOptions;
    protectPeriodConstE = protectPeriodConstE;
    UNPLACEHOLDER = UNPLACEHOLDER;
    SnapSourceSelectTypeE = SnapSourceSelectTypeE;

    /**
     * 表单
     */
    tableConfig: TableConfig;
    columnDefs: ColumnDef[];
    fsRest: Rest;
    vm: FormGroup;
    errorMessage: any;
    fsTableExpand = true;
    selectionChangeResult = false;
    modifyScheduleTableColumnDefs: ColumnDef[];

    /**
     * 策略的卡片表单
     */
    scheduleDefaultData: HyperCdpSchedule[] = [];
    initSelectVal: string;
    dataCardConfig: CardConfig;
    getBatchScheduleRest: Rest;
    scheduleBtnGroup: ButtonGroup;

    timestamp = this.timeService.formatUTC(this.timeService.currTime * 1e3, 'YYMMDDHHmmss', false).split(' ')[0];

    /**
     * title、placeholder文字
     */
    createTitle: string;
    placeholderName: string;
    placeholderSnapTag = this.str.rangeByteLengthErr(FsSnapTagLenE.Min, FsSnapTagLenE.Max);
    placeholderdescriptionLab = this.str.rangeByteLengthErr(FsSnapCreateDesLenE.Min, FsSnapCreateDesLenE.Max);

    maxNameLength = FsSnapCreateNameLenE.MultiMax;
    protectPeriodMax: protectPeriodConstE = protectPeriodConstE.maxDay;
    protectPeriodMin: protectPeriodConstE = protectPeriodConstE.min;

    /**
     * 快照、策略切换卡片宽度
     */
    multiTitleWidth = '405px';

    /**
     * 策略卡片宽度
     */
    multiCardWidth = Browser.name === 'ie' ? '260px' : '265px';

    /**
     * 对form表单的值进行类型检查
     */
    get vmValue(): CreateFsSnapFormValue {
        return this.vm.value as CreateFsSnapFormValue;
    }

    constructor(
        public str: FilesystemSnapshotStrService,
        private service: FilesystemSnapshotService,
        private utilService: UtilService,
        private scheduleService: ScheduleService,
        private scheduleStrService: ScheduleStrService,
        private buttonService: ButtonService,
        private lazyLoad: LazyloadService,
        private timeService: TimeService,
    ) { }

    ngOnInit(): void {
        this.createTitle = this.isCdp ? this.i18n.createCdpTitle : this.i18n.createTitle;

        this.initVm();
        this.initTable();
        this.initBtn();
        this.initDataCard();

        this.updateNameValidate();

        this.getBatchScheduleRest = this.scheduleService.getBatchRest(ScheduleTypeE.File, SystemVstoreId);

        // 在未传入已选文件系统时默认展开推拉表格
        this.fsTableExpand = this.selectedFs.length === 0;
    }

    selectionChange(): void {
        this.selectionChangeResult = true;
        this.updateNameValidate();
    }

    /**
     * 更新名称校验
     */
    updateNameValidate(): void {
        // 选择多个文件系统时，有四位序号
        this.maxNameLength = this.selectedFs.length > 1 ? FsSnapCreateNameLenE.MultiMax : FsSnapCreateNameLenE.SingleMax;
        this.placeholderName = this.str.rangeByteLengthErr(FsSnapCreateNameLenE.Min, this.maxNameLength);

        this.vm.get('name').setValidators([
            DMValidators.rangeByteLength(0, this.maxNameLength),
            this.str.snapshotNameValidator,
        ]);

        this.errorMessage.name.rangeByteLength = this.str.rangeByteLengthErr(FsSnapCreateNameLenE.Min, this.maxNameLength);
    }

    /**
     * 自动生成单个快照名
     * @param fsName 源Fs名称
     * @param i 序号
     * @returns
     */
    getNameSingle(fsName: string, i: number): string {
        const suffix = this.timestamp + i;
        return this.utilService.byteSubstring(fsName, FsSnapCreateNameLenE.SingleMax - suffix.length) + suffix;
    }

    /**
     * 自动生成多个快照名
     * @param prefix
     * @param suffix
     * @returns
     */
    getNameMulti(prefixOrigin: string, suffix: number): string {
        // 多个创建场景，序号长度为4位
        const suffixLength = FsSnapCreateNameLenE.SingleMax - FsSnapCreateNameLenE.MultiMax;
        let prefix = prefixOrigin;

        if (prefix.length > FsSnapCreateNameLenE.MultiMax) {
            prefix = prefix.substring(0, FsSnapCreateNameLenE.MultiMax);
        }

        return prefix + suffix.toString().padStart(suffixLength, '0');
    }

    /**
     * 初始化表格
     */
    initTable(): void {
        this.columnDefs = [
            {
                field: 'NAME',
                header: this.i18n.name,
                filterType: 'search',
                sortable: true,
            },
            {
                field: 'vstoreName',
                header: this.i18n.vStoreNameLab,
                ignore: this.isSimpleMode,
                columnFilter: true,
                render: (value: string, col: ColumnDef, data: FileSystem) => data.vstoreName || UNPLACEHOLDER,
            },
            {
                field: 'vstoreId',
                header: this.i18n.vStoreIdLab,
                columnFilter: true,
                ignore: this.isSimpleMode,
                hidden: true,
                render: (value: string, col: ColumnDef, data: FileSystem) => data.vstoreId || UNPLACEHOLDER,
            },
            {
                field: 'CAPACITY',
                header: this.i18n.capacityLab,
                align: 'right',
                columnFilter: true,
                render: (value: number) => this.utilService.adaptUnit(value, Consts.SECTOR).label,
            },
        ];

        this.tableConfig = {
            dataKey: 'ID',
        };

        this.fsRest = this.service.getFilesystemBatchRest();

        // 修改策略高危提示中，成员FS表格列配置
        this.modifyScheduleTableColumnDefs = [
            {
                field: 'NAME',
                header: this.scheduleStrService.table.nameLab,
            },
            {
                field: 'ID',
                header: this.scheduleStrService.table.idLab,
            },
        ];
    }

    /**
     * 初始化表单
     */
    initVm(): void {
        this.vm = new FormGroup({
            protectType: new FormControl(this.showSchedule ? SnapProtectTypeE.CdpSchedule : SnapProtectTypeE.Snap),
            name: new FormControl('', {
                validators: [
                    DMValidators.rangeByteLength(FsSnapCreateNameLenE.Min, this.maxNameLength),
                    this.str.snapshotNameValidator,
                ],
            }),
            description: new FormControl('', {
                validators: DMValidators.rangeByteLength(FsSnapCreateDesLenE.Min, FsSnapCreateDesLenE.Max),
            }),
            schedule: new FormControl(null, {
                validators: [
                    Validators.required,
                ],
            }),
            snapTag: new FormControl('', {
                validators: [
                    DMValidators.rangeByteLength(FsSnapTagLenE.Min, FsSnapTagLenE.Max),
                    this.str.snapTagValidator,
                ],
            }),
            isSecuritySnap: new FormControl(false),
            expiredTime: new FormControl(Number(protectPeriodConstE.defaultDay)),
            expiredTimeUnit: new FormControl(protectPeriodUnitE.day),
            isAutoDelete: new FormControl(false),
        }, { updateOn: 'blur' });

        this.errorMessage = {
            name: {
                rangeByteLength: this.str.rangeByteLengthErr(FsSnapCreateNameLenE.Min, FsSnapCreateNameLenE.SingleMax),
                snapshotName: this.str.snapshotNameErr(this.i18n.name),
            },
            description: {
                rangeByteLength: this.str.rangeByteLengthErr(FsSnapCreateDesLenE.Min, FsSnapCreateDesLenE.Max),
            },
            schedule: {
                required: this.str.requiredErr(this.i18n.scheduleLabel),
            },
            snapTag: {
                rangeByteLength: this.str.rangeByteLengthErr(FsSnapTagLenE.Min, FsSnapTagLenE.Max),
                snapTag: this.i18n.userSnapSyncTagValid,
            },
        };

        this.protectTypeChange(this.vmValue.protectType);
    }

    /**
     * 策略卡片初始化
     */
    initDataCard(): void {
        this.dataCardConfig = {
            title: {
                field: 'NAME',
            },
            tip: {
                render: (tip: string, config: CardTitleConfig, data): string => this.scheduleService.renderStrategy(data, true).join('; '),
            },
            rows: 12,
            pageStyle: 'default',
        };

        // 填入默认策略，没有策略的情况下需要DM下发创建
        this.scheduleDefaultData = [SIMPLE_CDP_SCHEDULE_NAS_DEFAULT] as unknown as HyperCdpSchedule[];

        if (this.modifySchedule) {
            this.initSelectVal = this.selectedFs[0].TIMINGSNAPSHOTSCHEDULEID;
        }
    }

    /**
     * 表单校验
     * @returns
     */
    validate(): Observable<boolean> {
        this.selectionChangeResult = true;
        if (!this.selectedFs.length) {
            return of(false);
        }

        return this.vm.validateOb();
    }

    /**
     * worm开关
     */
    wormEnabledChange(value: boolean): void {
        const protectPeriod = this.vm.get('expiredTime');
        const protectPeriodUnit = this.vm.get('expiredTimeUnit');
        const autoDelete = this.vm.get('isAutoDelete');

        if (value) {
            protectPeriod.enable();
            protectPeriodUnit.enable();
            autoDelete.enable();
            protectPeriod.markAsTouched();
            protectPeriodUnit.markAsTouched();
            autoDelete.markAsTouched();
        } else {
            protectPeriod.disable();
            protectPeriodUnit.disable();
            autoDelete.disable();
        }
    }

    /**
     * 单位变化
     * @param { value }
     */
    unitChanged({ value }: { value: protectPeriodUnitE }): void {
        const protectPeriod = this.vm.get('expiredTime');
        switch (value) {
            case protectPeriodUnitE.day:
                protectPeriod.setValue(Number(protectPeriodConstE.defaultDay));
                this.protectPeriodMax = protectPeriodConstE.maxDay;
                this.protectPeriodMin = protectPeriodConstE.min;
                break;
            case protectPeriodUnitE.month:
                protectPeriod.setValue(Number(protectPeriodConstE.defaultMonth));
                this.protectPeriodMax = protectPeriodConstE.maxMonth;
                this.protectPeriodMin = protectPeriodConstE.min;
                break;
            case protectPeriodUnitE.year:
                protectPeriod.setValue(Number(protectPeriodConstE.defaultYear));
                this.protectPeriodMax = protectPeriodConstE.maxYear;
                this.protectPeriodMin = protectPeriodConstE.min;
                break;
            default:
                break;
        }
    }

    /**
     * 保护类型改变。仅极简模式支持，可以选加入CDP计划
     * @param value
     */
    protectTypeChange(value: SnapProtectTypeE): void {
        if (value === SnapProtectTypeE.CdpSchedule) {
            this.vm.get('schedule').enable();

            // 快照相关表单禁用
            this.vm.get('name').disable();
            this.vm.get('description').disable();
            this.vm.get('snapTag').disable();

            // worm相关表单禁用
            this.vm.get('expiredTime').disable();
            this.vm.get('expiredTimeUnit').disable();
            this.vm.get('isAutoDelete').disable();
        } else {
            this.vm.get('schedule').disable();

            // 快照相关表单启用
            this.vm.get('name').enable();
            this.vm.get('description').enable();
            this.vm.get('snapTag').enable();

            // 快照场景，触发一下worm类型改变，避免worm相关表单失效
            this.wormEnabledChange(this.vmValue.protectType);
        }
    }

    /**
     * 高危提示
     * @returns
     */
    prompt(): PromptConfigFull[] {
        const prompts: PromptConfigFull[] = [];

        // 修改策略，会下发先移除再添加，会删除CDP，需要进行提示
        if (this.modifySchedule) {
            // 修改场景，只会传入一个LUN
            const oriScheduleId = this.selectedFs[0].TIMINGSNAPSHOTSCHEDULEID;
            if (this.vmValue.schedule.ID === oriScheduleId) {
                return [];
            }

            prompts.push({
                id: 'prompt-fs-modify-schedule',
                opType: 'warning',
                title: this.scheduleStrService.title.modifySchedule,
                content: this.scheduleStrService.removeHyperCDPScheduleFsMember(this.selectedFs[0].scheduleName),
                templateRef: this.modifyScheduleTableTemplate,
                canHidden: true,
                width: 700,
            });
        }

        if (this.vmValue.protectType === SnapProtectTypeE.Snap && this.vmValue.isSecuritySnap) {
            prompts.push({
                id: 'prompt-fsnap-createFsSnap',
                opType: 'warning',
                title: this.isCdp ? this.i18n.createCdpTitle : this.i18n.createTitle,
                content: this.i18n.createFsSnapHighRisk,
                width: 600,
            });
        }

        return prompts;
    }

    /**
     * 初始化按钮
     */
    initBtn(): void {
        this.scheduleBtnGroup = [this.buttonService.create({
            id: 'hyper-cdp-schedule-main-create-button',
            theme: 'primary',
            label: this.i18n.addNewScheduleBtn,
            permission: ['@hyper_cdp_W'],
            license: [LicenseKey.HyperCDP],
            command: () => {
                this.lazyLoad.appendComponent(CreateComponent, {
                    type: ScheduleTypeE.File,
                    vstore: {
                        label: SYSTEM_VSTORE_NAME,
                        value: SystemVstoreId,
                    },
                    onClose: (createObj: HyperCdpSchedule) => {
                        if (!createObj) {
                            return;
                        }

                        this.scheduleDataCard?.autoSelectLastPageItemByRule({
                            key: 'ID',
                            value: createObj.ID,
                        });
                    },
                });
            },
        })];
    }

    /**
     * 加入CDP计划场景
     * @returns
     */
    getAddCdpScheduleCmds(): Command[] {
        const cmds: Command[] = [];
        const needCreateSchedule = this.vmValue.schedule.ID === undefined;

        if (this.modifySchedule) {
            // 修改场景，只会传入一个FS
            const oriScheduleId = this.selectedFs[0].TIMINGSNAPSHOTSCHEDULEID;

            // 先判断是否新选中的和老的一样，是的话直接关闭
            if (this.vmValue.schedule.ID === oriScheduleId) {
                return [];
            }

            // 先下发移除
            const removeHyperCDPScheduleCmd: Command = {
                id: 'removeHyperCDPSchedule',
                name: this.i18n.removeMemberFS.replace('{0}', this.selectedFs[0].NAME)
                    .replace('{1}', (this.selectedFs[0] as FileSystem).scheduleName),
                action: this.scheduleService.removeAssociate(oriScheduleId, this.selectedFs[0].ID,
                    MO.FILE_SYSTEM, { doException: false }, SystemVstoreId),
            };
            cmds.push(removeHyperCDPScheduleCmd);
        }

        // 如果是DM预置策略，需要先下发创建
        if (needCreateSchedule) {
            const createHyperCDPScheduleCmd: Command = {
                id: 'createHyperCDPSchedule',
                name: this.i18n.createScheduleName(this.vmValue.schedule.NAME),
                action: this.scheduleService.create(
                    this.getDefaultScheduleParams(),
                    SystemVstoreId,
                    { doException: false },
                ),
            };
            cmds.push(createHyperCDPScheduleCmd);
        }

        this.selectedFs.forEach((fs) => {
            cmds.push({
                id: `addFsToSchedule_${fs.NAME}`,
                deps: ['createHyperCDPSchedule'],
                name: this.i18n.addFsResultName(fs.NAME, this.vmValue.schedule.NAME),
                action: (res: JobResponse) => {
                    const createdSchedule = res && res.data as HyperCdpSchedule;

                    const scheduleId = (needCreateSchedule && createdSchedule) ? createdSchedule.ID : this.vmValue.schedule.ID;
                    return this.scheduleService.addAssociateMember(scheduleId, fs.ID, MO.FILE_SYSTEM,
                        { doException: false }, fs.vstoreId);
                },
            });
        });

        // DM自动创建的策略需要立即启动
        if (needCreateSchedule) {
            cmds.push({
                id: 'activate',
                deps: ['createHyperCDPSchedule'],
                name: this.i18n.activateCdpScheduleMsg.replace('{0}', this.vmValue.schedule.NAME),
                action: (res: JobResponse) => {
                    const createdSchedule = res && res.data as HyperCdpSchedule;

                    return this.scheduleService.activate(
                        createdSchedule.ID,
                        SystemVstoreId,
                        { doException: false },
                    );
                },
            });
        }

        return cmds;
    }

    /**
     * 获取DM预置FS定时计划下发参数
     * @returns
     */
    getDefaultScheduleParams(): HyperCdpSchedule {
        const defaultSchedule = SIMPLE_CDP_SCHEDULE_NAS_DEFAULT;

        const params: HyperCdpSchedule = {
            NAME: defaultSchedule.NAME,
            FREQUENCYVALUE: defaultSchedule.FREQUENCYVALUE,
            FREQUENCYNUM: defaultSchedule.FREQUENCYNUM,
            DAYHOURS: JSON.parse(defaultSchedule.DAYHOURS),
            DAYMINUTE: defaultSchedule.DAYMINUTE,
            DAILYSNAPSHOTNUM: defaultSchedule.DAILYSNAPSHOTNUM,
            WEEKLYDAYS: JSON.parse(defaultSchedule.WEEKLYDAYS),
            STARTTIMEOFWEEK: defaultSchedule.STARTTIMEOFWEEK,
            WEEKLYSNAPSHOTNUM: defaultSchedule.WEEKLYSNAPSHOTNUM,
            OBJECTTYPE: objectTypeE.file,
            vstoreId: SystemVstoreId,
        };

        return params;
    }

    /**
     * 创建快照场景
     * @returns
     */
    getCrateSnapCmds(): Command[] {
        const cmds: Command[] = [];
        const inputName = this.vmValue.name;
        this.selectedFs.forEach((fs, index) => {
            let tempName: string;

            // 若不输入名称，则快照名称为文件系统 + 时间戳 + 序号
            if (inputName === '') {
                tempName = this.getNameSingle(this.isCdp ? 'FilesystemCDP' : 'FilesystemSnapshot', index);
            } else {
                // 若输入名称，选择单个文件系统，名称则为所输入的名称(255)
                // 若输入名称，选择多个文件系统，名称则为所输入的名称(251) + 四位序号
                tempName = this.selectedFs.length === 1 ? inputName : this.getNameMulti(inputName, index);
            }

            const params: FilesystemSnapshot = {
                NAME: tempName,
                PARENTID: fs.ID,
                vstoreId: fs.vstoreId,
                description: this.vmValue.description,
                snapTag: this.vmValue.snapTag,
                isSecuritySnap: 'false',
            };

            if (this.isCdp) {
                params.snapType = SnapTypeE.HyperCDP;
            }

            if (this.vmValue.isSecuritySnap) {
                params.isSecuritySnap = 'true';
                params.isAutoDelete = this.vmValue.isAutoDelete ? 'true' : 'false';
                params.expiredTime = String(this.vmValue.expiredTime);
                params.expiredTimeUnit = this.vmValue.expiredTimeUnit;
            }

            cmds.push({
                name: this.str.createFsResultName(params.NAME, this.isCdp),
                action: this.service.create(params, undefined, this.isCdp),
            });
        });

        return cmds;
    }

    /**
     * 获取下发的cmd命令
     * @returns
     */
    buildCmds(): Command[] {
        let cmds: Command[] = [];

        if (this.vmValue.protectType === SnapProtectTypeE.CdpSchedule) {
            cmds = this.getAddCdpScheduleCmds();
        } else {
            cmds = this.getCrateSnapCmds();
        }

        return cmds;
    }
}
